import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainPoints() {
  const problems = ['Recetas de internet que nunca te quedan igual que en el video', 'Gastás en ingredientes y tirás la mitad porque la masa no levantó', 'Los glaseados te salen feos y no sabés qué estás haciendo mal', 'Cobrás cualquier cosa porque no tenés una fórmula de precios', 'El packaging te da vergüenza y no podés mostrar el producto en Instagram', 'Querés emprender pero arrancás y parás, arrancás y parás', 'La semana termina igual que empezó — sin ningún peso extra en el bolsillo'];
  return <section className="w-full bg-[#FFFFFF] py-16 md:py-24" data-id="element-147">
      <div className="max-w-4xl mx-auto px-4 sm:px-6" data-id="element-148">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-149">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2B1F] text-center mb-6 leading-tight" data-id="element-150">
            ¿Cuántos domingos más vas a pasar mirando videos de minidonas sin
            animarte a empezar?
          </h2>

          <div className="text-center mb-12 space-y-6 max-w-3xl mx-auto" data-id="element-151">
            <p className="text-lg md:text-xl text-[#3E2B1F]/80 leading-relaxed" data-id="element-152">
              Querés tener tu propio negocio. Algo tuyo. Algo que podés hacer
              desde casa, a tu ritmo, con tus propias manos. Pero cada vez que
              intentás arrancar, aparece lo mismo:
            </p>
            <p className="text-lg md:text-xl text-[#3E2B1F]/80 leading-relaxed" data-id="element-153">
              La masa no te queda. Los glaseados se corren o quedan opacos. No
              sabés cuánto cobrar. Y terminás pensando que "capaz no es para
              vos".
            </p>
            <p className="text-2xl md:text-3xl font-serif font-bold text-[#B66A2C] mt-8" data-id="element-154">
              No es falta de talento. Es falta de un sistema.
            </p>
          </div>

          <div className="max-w-2xl mx-auto" data-id="element-155">
            <h3 className="font-serif text-2xl md:text-3xl font-bold text-[#3E2B1F] mb-6 text-center" data-id="element-156">
              Lo que pasa sin el Mega Pack:
            </h3>
            <div className="bg-[#F7F2EA] border border-[#E7DDD2] rounded-2xl overflow-hidden shadow-sm p-2" data-id="element-157">
              <div className="divide-y divide-[#E7DDD2]" data-id="element-158">
                {problems.map((problem, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1,
                duration: 0.4
              }} className="flex items-start gap-4 p-4 md:p-5" data-id="element-159">
                    <div className="bg-white p-1.5 rounded-full shadow-sm flex-shrink-0 mt-0.5" data-id="element-160">
                      <XIcon className="w-5 h-5 text-[#B66A2C]" data-id="element-161" />
                    </div>
                    <p className="text-[#3E2B1F]/90 text-base md:text-lg font-medium leading-relaxed" data-id="element-162">
                      {problem}
                    </p>
                  </motion.div>)}
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}